import React, { FunctionComponent } from 'react'
import { Link, Text, Tooltip, useIsDesignLanguage, DesignLanguage, Message } from '@afterpaytouch/core'

import { useCheckoutState, useInitialData, useIsPickup } from '../../../state'
import { useCheckoutSizes } from '../../../utils/responsive'
import { useTranslation } from '../../../utils/convergence'
import styles from '../style.module.css'
import { useCloseCheckout } from '../../../utils/close'
import { Trans } from '../../../utils/convergence'

interface TooltipMessageProps {
  addressContainerRef: React.RefObject<HTMLElement>
}

export const TooltipMessage: FunctionComponent<TooltipMessageProps> = ({ addressContainerRef }): JSX.Element | null => {
  const { t } = useTranslation()
  const { checkout } = useCheckoutState()
  const isPickup = useIsPickup()
  const { smallTextSize } = useCheckoutSizes()
  const { addressMode } = useInitialData()
  const isArcadeDesignLanguage = useIsDesignLanguage(DesignLanguage.Arcade)
  const close = useCloseCheckout()
  const isLockingShippingAddress = isPickup || addressMode === 'SHIP_TO_ORDER_ADDRESS'

  const merchantLink = <Link onClick={async () => await close()} target='_blank' kind='Underline' />

  const renderPickupTooltipContent = (): JSX.Element => {
    return (
      <>
        <div className={styles.tooltipArrow} />
        <Text renderAs='span' size={smallTextSize}>
          <Trans
            components={{ merchantLink }}
            i18nKey={isPickup ? 'summary:pickUpTooltip' : 'summary:shippingToAddressTooltip'}
            values={{ merchantName: checkout?.merchant?.name }}
          />
        </Text>
      </>
    )
  }

  if (!isLockingShippingAddress) {
    return null
  }

  if (isArcadeDesignLanguage) {
    return (
      <div className={styles.tooltipWrapper}>
        <Message
          testNameSpace='shipping-address-cash-tooltip'
          kind='Success'
          iconName='CheckFill'
          heading={t(isPickup ? 'summary:pickUpTooltipHeading' : 'summary:shippingToAddressTooltipHeading')}
          description={
            <Text renderAs='span' size={smallTextSize}>
              <Trans
                components={{ merchantLink }}
                i18nKey={isPickup ? 'summary:pickUpTooltip' : 'summary:shippingToAddressTooltip'}
                values={{ merchantName: checkout?.merchant?.name }}
              />
            </Text>
          }
        />
      </div>
    )
  }

  return (
    <div className={styles.tooltipWrapper}>
      <Tooltip
        id='pickup-tooltip'
        triggerRef={addressContainerRef}
        usePortal={false}
        content={renderPickupTooltipContent()}
        bubbleSize={{ width: '100%' }}
        inline
        hasCaret={false}
      />
    </div>
  )
}
